import { BaseApiFetchError } from '../../utility/error/BaseApiFetchError'
import { BaseApiValidationError } from '../../utility/error/BaseApiValidationError'

export class UserBookingsFetchError extends BaseApiFetchError {
  constructor(url: string, params: Record<string, any>, originalError: any) {
    super('user-bookings', url, params, originalError)

    // Override name for backwards compatibility using Object.defineProperty like CustomError
    Object.defineProperty(this, 'name', {
      value: 'UserBookingsFetchError',
      enumerable: true,
    })
  }
}

export class UserBookingsValidationError extends BaseApiValidationError {
  public readonly partialBookings: any[]
  public readonly validationErrors: string[]

  constructor(
    url: string,
    params: Record<string, any>,
    rawResponse: any,
    originalError: any,
    partialBookings: any[] = [],
    validationErrors: string[] = [],
  ) {
    super('user-bookings', url, params, rawResponse, originalError)

    // Override name for backwards compatibility
    Object.defineProperty(this, 'name', {
      value: 'UserBookingsValidationError',
      enumerable: true,
    })

    this.partialBookings = partialBookings
    this.validationErrors = validationErrors
  }

  /**
   * Get context data for Sentry or logging
   * Includes partial success information for debugging
   */
  override getContext() {
    const baseContext = super.getContext()

    return {
      ...baseContext,
      partialBookingsCount: this.partialBookings.length,
      validationErrorsCount: this.validationErrors.length,
      validationErrors: (() => {
        try {
          return JSON.stringify(this.validationErrors)
        } catch {
          return '[unserializable]'
        }
      })(),
      hasPartialSuccess: this.partialBookings.length > 0,
      totalBookingsInResponse:
        this.partialBookings.length + this.validationErrors.length,
    }
  }
}
